import { useUser } from '@/context/userContext';
import { LayoutSpinner, LayoutWrapper } from '../Layouts/styles';
import { ReactNode, useState } from 'react';
import { useEffectOnce } from '@/hooks/useEffectOnce';

type RefetchUserRouteType = {
  children: ReactNode;
};

export const RefetchUserWrapper = ({ children }: RefetchUserRouteType) => {
  const [loading, setLoading] = useState(true);

  const { refetchUser } = useUser();

  useEffectOnce(() => {
    setLoading(true);

    refetchUser()
      .then(() => setLoading(false))
      .catch(() => {
        setLoading(false);
      });
  });

  if (loading) {
    return (
      <LayoutWrapper>
        <LayoutSpinner />
      </LayoutWrapper>
    );
  }

  return <>{children}</>;
};
